export const desktopOS = [
    {
      label: 'HSS',
      value: 72,
    },
    {
      label: 'CLS',
      value: 16,
    },
    {
      label: 'BMS',
      value: 3,
    },
    {
      label: 'BPR-100',
      value: 2,
    },
    {
      label: 'GTW-200',
      value: 4,
    },
  ];
  
  export const mobileOS = [
    {
      label: 'Android',
      value: 70,
    },
    {
      label: 'iOS',
      value: 28,
    },
    {
      label: 'Other',
      value: 0,
    },
  ];
  
  export const platforms = [
    {
      label: 'Mobile',
      value: 59,
    },
    {
      label: 'Desktop',
      value: 40,
    },
  ];
  
  const normalize = (v, v2) => Number.parseFloat(((v * v2) / 100).toFixed(2));
  
  export const mobileAndDesktopOS = [
    ...mobileOS.map((v) => ({
      ...v,
      label: v.label === 'Other' ? 'Other (Mobile)' : v.label,
      value: normalize(v.value, platforms[0].value),
    })),
    ...desktopOS.map((v) => ({
      ...v,
      label: v.label === 'Other' ? 'Other (Desktop)' : v.label,
      value: normalize(v.value, platforms[1].value),
    })),
  ];
  
  export const qtyFormatter = (item) => `${item.value}`;
  export const valueFormatter = (item) => `C$${item.value}`;